import React,{useId} from 'react';

/** Clip passing glints to the artwork's alpha edge, including concealed fronts. */
export default function LegendaryPatchSparkle({image,delay,aspectRatio=3/4}:{image:string;delay?:string;aspectRatio?:number}){
 const id='patch-edge-'+useId().replace(/:/g,'');
 const height=300/aspectRatio;
 return <svg className="patch-border-sparkle" viewBox={`0 0 300 ${height}`} aria-hidden="true" focusable="false" style={{'--patch-sparkle-delay':delay||'0s'} as React.CSSProperties}>
  <defs>
   <filter id={id+'-edge'} filterUnits="userSpaceOnUse" x="0" y="0" width="300" height={height} colorInterpolationFilters="sRGB">
    <feMorphology in="SourceAlpha" operator="erode" radius="2.5" result="interior"/>
    <feComposite in="SourceAlpha" in2="interior" operator="out" result="edge"/>
    <feFlood floodColor="#FFF2CD" result="gold"/>
    <feComposite in="gold" in2="edge" operator="in"/>
   </filter>
   <filter id={id+'-rays'} filterUnits="userSpaceOnUse" x="-10" y="-10" width="320" height={height+20}>
    <feMorphology in="SourceAlpha" operator="dilate" radius="5 .3" result="across"/>
    <feMorphology in="SourceAlpha" operator="dilate" radius=".3 5" result="up"/>
    <feMerge result="rays"><feMergeNode in="across"/><feMergeNode in="up"/></feMerge>
    <feGaussianBlur in="rays" stdDeviation=".6" result="softRays"/>
    <feFlood floodColor="#FFE5A3" floodOpacity=".65" result="light"/>
    <feComposite in="light" in2="softRays" operator="in"/>
    <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
   </filter>
   <linearGradient id={id+'-light'} gradientUnits="userSpaceOnUse" x1="138" y1="0" x2="162" y2="0">
    <stop stopColor="white" stopOpacity="0"/><stop offset=".5" stopColor="white"/><stop offset="1" stopColor="white" stopOpacity="0"/>
   </linearGradient>
   <mask id={id+'-glints'} maskUnits="userSpaceOnUse" x="0" y="0" width="300" height={height}>
    <g className="patch-border-glint"><path d={`M138 ${height/2-360}H162L150 ${height/2}Z`} fill={`url(#${id}-light)`}/></g>
    <g className="patch-border-glint patch-border-glint-later"><path d={`M138 ${height/2-360}H162L150 ${height/2}Z`} fill={`url(#${id}-light)`}/></g>
   </mask>
  </defs>
  <g filter={`url(#${id}-rays)`}><image href={image} width="300" height={height} preserveAspectRatio="xMidYMid meet" filter={`url(#${id}-edge)`} mask={`url(#${id}-glints)`}/></g>
 </svg>;
}
